import * as R from "ramda";

import { useEffect, useState } from "react";

import qs from "query-string";

//key: a name of query string var
//fallbackValue: fallback if no key is found in qs
export default function useQueryString(key, fallbackValue) {
  const getQsValue = R.ifElse(R.has(key), R.prop(key), () =>
    fallbackValue ? fallbackValue : "",
  );

  const [value, setValue] = useState(
    getQsValue(qs.parse(window.location.search)),
  );

  useEffect(() => {
    const url = new URL(window.location);
    if (value) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }

    window.history.pushState({}, "", url);
  }, [key, value]);

  return [value, setValue];
}
